<template>
  <div>
    <div class="con">

    <h3 style="marginBottom:20px">尊贵的VIP：</h3>
    <h2>
      非常抱歉,
      <span style="color:red">您当前尚未购买此服务</span>
      ，请点击
      <span style="color:red" class="confirm" @click="back">确定</span>
      返回
    </h2>
    <h3 style="color:#999">{{times}}秒后将自动返回...</h3>
    </div>
  </div>
</template>

<script>
export default {
  mounted(){
    var x=0
    var timer=setInterval(()=>{
      x++
      this.times--
      if(this.times==0){
        this.back()
        clearInterval(timer)
      }
      if(x==6){
       clearInterval(timer)
      }
    },1000)
  },
  data(){return{
    times:5,
  }},
  methods:{
    back(){
      this.$router.push('/')
    }
  }
};
</script>

<style scoped>
.con{
  text-align: left;
  margin-left: 20px;
  margin-top: 20px;
}
.confirm{
  text-decoration:underline;
  font-size: 24px;
  cursor: pointer;
}
</style>